// This mixin is used to handle marketing signup for the marketing signup component

import { Cookies } from 'quasar'
import User from 'src/models/user/User'
import FormValidationMixin from 'src/modules/admin/mixins/FormValidationMixin'
export default {
  data () {
    return {
      firstName: null,
      lastName: null,
      emailAddress: null,
      acknowledgedTermsOfService: false,
      loading: false,
      success: false
    }
  },
  mixins: [FormValidationMixin],
  methods: {
    signup () {
      this.validateForm(async () => {
        const user = new User({
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.emailAddress,
          acknowledgedTermsOfService: this.acknowledgedTermsOfService
        })

        this.loading = true
        const result = await user.createUserMarketingSubscriptions()
        this.loading = false

        if (result.errors && result.errors.length) {
          this.$mh.showErrors(result.errors)
          return
        }

        this.success = true
        Cookies.set('registeredMarketingSignup' + this.currentSite.id, true)
        this.$trackEvent(this.$customerEvents.SUBSCRIBED_TO_MARKETING_LISTS)
      })
    }
  }
}
